
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'

var settings = require('./settings/' + process.env.NODE_ENV + '.json')

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: settings.api,

  providers: {
    google: {
      tokenPath: 'token',
      clientId: settings.auth.google,
      redirectUri: settings.url + '/login'
    }
  }
})
